import React, { useState } from 'react';
import { useClassName } from 'common/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import useCustomStyle from '../../hooks';
import useSlider from 'public/screens/Home/Components/useSlider';
import './carousel-type-e.less';
import CarouselAsset from './CarouselAsset';
import CarouselCard from './CarouselCard';
import CarouselControls from '../CarouselControls';
import CarouselCounter from '../CarouselCounter';
import CarouselArrows from '../CarouselArrows';
import TestimonialCard from './TestimonialCard';
import { toStyleObject } from '../../utils';

function getBreakpoints(component) {
  const slidesPerView = component?.fields?.settings?.find(
    (setting) => setting.fields.key === '--slides-per-view'
  );
  if (!slidesPerView) return {};
  return {
    0: {
      slidesPerView: slidesPerView.fields.mobileValue,
    },
    768: {
      slidesPerView: slidesPerView.fields.tabletValue,
    },
    1128: {
      slidesPerView: slidesPerView.fields.desktopValue,
    },
  };
}

export default function CarouselTypeE({ component, refs, handleTrack }) {
  const [paused, setPaused] = useState(false);
  const classNames = useClassName('LPCarouselTypeE');
  const [setRef, styles] = useCustomStyle(component.fields.settings);
  const [props, methods, state] = useSlider();
  const slides = component.fields.slides;
  const hideControls = styles['--hide-controls'] === 'true';
  const useBullets = styles['--use-bullets'] === 'true';

  return (
    <div ref={setRef} className={classNames('root')}>
      <div className={classNames('container')}>
        <Swiper
          height={500}
          spaceBetween={parseInt(styles['--space-between']) || 20}
          speed={100}
          loop={slides.length > 1}
          watchOverflow
          allowTouchMove={slides.length > 1}
          breakpoints={getBreakpoints(component)}
          {...props}>
          {slides.map((slide, index) => (
            <SwiperSlide
              key={index}
              className={classNames('slide-container')}
              style={toStyleObject(
                Object.fromEntries(
                  Object.entries(styles)
                    .filter(([key]) => key.startsWith('--slide'))
                    .map(([key, value]) => [key.replace('--slide-', ''), value])
                )
              )}>
              {() => {
                return slide.sys.contentType.sys.id === 'lpAsset' ? (
                  <CarouselAsset slide={slide} setPaused={setPaused} />
                ) : slide.sys.contentType.sys.id === 'testimonial' ? (
                  <TestimonialCard slide={slide} handleTrack={handleTrack} />
                ) : (
                  <CarouselCard
                    slide={slide}
                    setPaused={setPaused}
                    refs={refs}
                  />
                );
              }}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {slides.length > 1 && !hideControls && (
        <CarouselControls settings={component.fields.settings}>
          <CarouselCounter
            current={state.activeIndex + 1}
            total={slides.length}
            next={methods.slideNext}
            goTo={slides.length > 1 ? methods.slideToLoop : methods.slideTo}
            paused={paused}
            autoplayDuration={component.fields.autoplayDuration}
            type={component.fields.type}
            theme={component.fields.theme}
            useBullets={useBullets}
          />
          <div className={classNames('arrows-container')}>
            <CarouselArrows
              next={methods.slideNext}
              prev={methods.slidePrev}
              type={component.fields.type}
              theme={component.fields.theme}
              settings={component.fields.settings}
              trackDirection={(direction) =>
                handleTrack && handleTrack(direction)
              }
            />
          </div>
        </CarouselControls>
      )}
    </div>
  );
}
